import AppLogo from './Images/logo-hat-blue.png';

export const Resources = {
    Logo: AppLogo
}